import { motion } from "framer-motion";
import { Reveal, Label } from "./Motion";
import { HAMPERS } from "../data";

export const Hampers = ({ scrollTo }) => (
  <section id="hampers" data-testid="hampers" className="relative py-24 md:py-36 bg-[#EAE5DC]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <Reveal><Label>Curated Gifting</Label></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2c2826] leading-[1.02]">
            Hampers for every<br /><span className="italic text-[#985F47]">occasion.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-[#5a5451] leading-relaxed">
            Thoughtfully assembled from our own collection — for celebrations at home
            and gifting across the boardroom.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-5 md:gap-6">
        {HAMPERS.map((h, i) => (
          <Reveal key={h.id} delay={i * 0.1}>
            <motion.button
              data-testid={`hamper-${h.id}`}
              onClick={() => scrollTo("builder")}
              whileHover="hover"
              className="group relative block w-full text-left overflow-hidden"
            >
              <div className="relative aspect-[16/11] overflow-hidden bg-[#D6CFC4]">
                <motion.img
                  src={h.img} alt={h.name}
                  variants={{ hover: { scale: 1.05 } }}
                  transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c2826]/70 via-[#2c2826]/10 to-transparent" />
                <div className="absolute bottom-0 left-0 p-7 md:p-9">
                  <h3 className="font-serif text-3xl md:text-4xl text-[#F7F5F0]">{h.name}</h3>
                  <p className="mt-3 max-w-md text-[#e7ddcf] text-sm md:text-base leading-relaxed">{h.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[#F7F5F0] text-sm border-b border-[#F7F5F0]/50 pb-0.5 group-hover:border-[#E8942E] group-hover:text-[#E8942E] transition-colors duration-300">
                    Build yours &rarr;
                  </span>
                </div>
              </div>
            </motion.button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
